import React from 'react';

import ProcurementContractManagement from '../../procurement_contract_management/ProcurementContractManagement';
import { useProcurement } from '../context/ProcurementContext';
import ContractManagementDashboard from '../face/contract-management/ContractManagementDashboard';

const ProcurementContractManagementDashboardTab = () => {
    const { settings, routes } = useProcurement();

    if (settings.isProcurementRedesignEnabled) {
        return <ContractManagementDashboard />;
    }

    return (
        <ProcurementContractManagement
            fetchContractStatsUrl={routes.fetchContractStatsUrl}
            supplierContractsTermOverduesIndexUrl={routes.fetchSupplierContractsTermOverduesIndexUrl}
        />
    );
};

export default ProcurementContractManagementDashboardTab;
